// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import App from "./App";
import { router } from "./router/router";
import { store } from "./store/store";
import firebase from "firebase";
import upperFirst from "lodash/upperFirst";
import camelCase from "lodash/camelCase";

/*
import * as Sentry from "@sentry/browser";
import * as Integrations from "@sentry/integrations";

Sentry.init({
  dsn: "https://baf4f6b0050a4c56b08bbd427fd1edab@sentry.io/1439390",
  integrations: [
    new Integrations.Vue({
      Vue,
      attachProps: true
    })
  ]
});
*/

import VeeValidate from "vee-validate";
import VeeValidateMessagesNL from "vee-validate/dist/locale/nl";
VeeValidate.Validator.localize({ nl: VeeValidateMessagesNL });
Vue.use(VeeValidate, {
  locale: "nl",
  events: ""
});

import Buefy from "buefy";
Vue.use(Buefy);

import InstantSearch from "vue-instantsearch";
Vue.use(InstantSearch);
import "instantsearch.css/themes/reset.css";

import VueAutosuggest from "vue-autosuggest";
Vue.use(VueAutosuggest);

// Don't show Vue production warning
Vue.config.productionTip = false;

// Define app
let app;

// Vue-router navigation guards
router.beforeEach((to, from, next) => {
  const currentUser = firebase.auth().currentUser;

  const requiresAuth = to.matched.some(record => record.meta.requiresAuth);
  if (requiresAuth && !currentUser) {
    next("/login");
  } else if (store.getters.getIsAnyModalOpen) {
    store.commit("closeAllModals");
    next(false);
  } else {
    next();
  }
});

// Relaunch app when user logs in or out. Also don't create new app if user still logged in or out.
firebase.auth().onAuthStateChanged(user => {
  if (!app) {
    app = new Vue({
      el: "#app",
      router: router,
      store: store,
      render: h => h(App)
    });
  }
});

// Import globals.js and use as mixin
import Globals from "./mixins/globals.js";

Vue.mixin(Globals);

// Import vue base components globally
const requireComponent = require.context(
  "./components/base-components",
  false,
  /base-[\w-]+\.vue$/
);

requireComponent.keys().forEach(fileName => {
  const componentConfig = requireComponent(fileName);

  const componentName = upperFirst(
    camelCase(fileName.replace(/^\.\//, "").replace(/\.\w+$/, ""))
  );

  Vue.component(componentName, componentConfig.default || componentConfig);
});



// WEBPACK FOOTER //
// ./src/main.js